import { render } from "./BbamarketingView.vue?vue&type=template&id=b05fe9e8"
import script from "./BbamarketingView.vue?vue&type=script&lang=js"
export * from "./BbamarketingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__